import { createMachine } from 'xstate';

export const marcheMachine = createMachine({
  id: 'marche',
  initial: 'ma-Catwalk Walking',
  states: {
    "ma-Catwalk Walking": { on: { "NEXT01": "ma-Drunk Walk" }},
    "ma-Drunk Walk": { on: { "NEXT01": "ma-Holding Walk" }},
    "ma-Holding Walk": { on: { "NEXT01": "ma-Jogging" }},
    "ma-Jogging": { on: { "NEXT01": "ma-Reloading" }},
    "ma-Reloading": { on: { "NEXT01": "ma-Run Look Back" }},
    "ma-Run Look Back": { on: { "NEXT01": "ma-Standard Walk" }},
    "ma-Standard Walk": { on: { "NEXT01": "ma-Strut Walking" }},
    "ma-Strut Walking": { on: { "NEXT01": "ma-Texting And Walking" }},
    "ma-Texting And Walking": { on: { "NEXT01": "ma-Walk" }},
    "ma-Walk": { on: { "NEXT01": "ma-Walk 2" }},
    "ma-Walk 2": { on: { "NEXT01": "ma-Catwalk Walking" }},
  }
});
